// extracted by mini-css-extract-plugin
module.exports = {"headline":"Login_headline__d15_X","body":"Login_body__JtsXn","form-container":"Login_form-container__Sc1oV","error":"Login_error__6SziI"};